import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {}, 
    lng: localStorage.getItem("langSlug") || "en", 
    fallbackLng: localStorage.getItem("langSlug") || navigator.language.split("-")[0] || "en",
    interpolation: {
      escapeValue: false, 
    },
    react: {
      useSuspense: false, 
    },
  });

export default i18n;
